import type { ReactNode } from 'react'
import { cn } from '@/components/ui'

/**
 * Le nuage numéroté (forme Umiros Form_01) : étapes, séances, tranches.
 *
 * - `fait` : nuage lavande plein ;
 * - `a-venir` : nuage au trait prune — un nuage prune sous un nuage blanc en
 *   retrait de 2px. Un filtre de contour épaississait aussi le chiffre ; ce
 *   montage-ci ne touche qu'à la forme.
 *
 * La forme est **embarquée** (`--forme-nuage`, `oasis-2027.css`) : un masque
 * vers un SVG externe disparaît quand le navigateur refuse de le charger.
 */
export function Nuage({
  children,
  etat = 'fait',
  taille = 'md',
  incline = 'gauche',
  className,
}: {
  /** Un numéro ou une coche. */
  children: ReactNode
  etat?: 'fait' | 'a-venir'
  taille?: 'sm' | 'md'
  incline?: 'gauche' | 'droite'
  className?: string
}) {
  return (
    <span
      className={cn(
        'u-nuage font-black tracking-[-0.04em] text-ink',
        etat === 'a-venir' && 'u-nuage-avenir',
        taille === 'md' ? 'size-[58px] text-[22px]' : 'size-[44px] text-[18px]',
        incline === 'gauche' ? '-rotate-6' : 'rotate-6',
        className,
      )}
    >
      <span>{children}</span>
    </span>
  )
}
